var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourcesLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.366,
    height: 20.759,
    viewBox: "0 0 21.366 20.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sources_Library_icon",
    "data-name": "Sources Library icon",
    transform: "translate(166.766 130.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4820",
    "data-name": "Path 4820",
    d: "M18.967,6.823,15.356,8.715,9.643,11.7,3.911,8.715.3,6.823",
    transform: "translate(-165.716 -122.224)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4821",
    "data-name": "Path 4821",
    d: "M18.967,4.844,15.356,6.736,9.643,9.716,3.911,6.736.3,4.844",
    transform: "translate(-165.716 -124.743)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4822",
    "data-name": "Path 4822",
    d: "M18.967,5.191,15.356,7.083,11.745,8.974l-2.1,1.089-2.1-1.089L3.911,7.083.3,5.191,9.643.3Z",
    transform: "translate(-165.716 -129.587)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcesLight);
export default __webpack_public_path__ + "static/media/Sources-Light.c2e97ca0490ceb85142e3271dbbf768f.svg";
export { ForwardRef as ReactComponent };